"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CALENDAR_DAY = void 0;
exports.isAgentToolCalendarDay = isAgentToolCalendarDay;
exports.calendarDayFormat = calendarDayFormat;
exports.calendarDayFromToday = calendarDayFromToday;
exports.calendarDaysFromToday = calendarDaysFromToday;
/**
 * Calendar days as `YYYY-MM-DD` in a named time zone. Free of Node-only
 * modules: the client reads these through the package index.
 */
/** A calendar day as `YYYY-MM-DD`; `isAgentToolCalendarDay` checks the calendar has it. */
exports.CALENDAR_DAY = /^(\d{4})-(\d{2})-(\d{2})$/u;
/** Whether the text names a day the calendar has, as `YYYY-MM-DD`. */
function isAgentToolCalendarDay(text) {
    const match = exports.CALENDAR_DAY.exec(text);
    if (!match)
        return false;
    const [year, month, day] = match.slice(1).map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));
    return (date.getUTCFullYear() === year &&
        date.getUTCMonth() === month - 1 &&
        date.getUTCDate() === day);
}
/** Null for a name no calendar of the runtime knows. */
function calendarDayFormat(timeZone) {
    try {
        return new Intl.DateTimeFormat('en-US', {
            timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
    }
    catch {
        return null;
    }
}
/**
 * The calendar day it is in the time zone, moved by whole days. `now` is the
 * instant that counts as today (epoch milliseconds).
 */
function calendarDayFromToday(timeZone, days, now = Date.now()) {
    const parts = Object.fromEntries(calendarDayFormat(timeZone)
        .formatToParts(new Date(now))
        .map(part => [part.type, Number(part.value)]));
    return new Date(Date.UTC(parts.year, parts.month - 1, parts.day + days))
        .toISOString()
        .slice(0, 10);
}
/** Whole calendar days from today in the time zone to the day. */
function calendarDaysFromToday(timeZone, day) {
    const today = calendarDayFromToday(timeZone, 0);
    return ((Date.parse(`${day}T00:00:00Z`) - Date.parse(`${today}T00:00:00Z`)) /
        86_400_000);
}
